import { Attachements } from "../onboarding-assesment-interface/onboarding-assesment.interface";

export class OnboardingAssesmentModel {

    private onboardingid!: number;
    private updatedbyrole!: string;
    private pias_is_agree!: boolean;
    private pias_declaration_date!: string;
    private onboarding_name!: string;
    private attachments!: Attachements[];
    private remarkContent!: string;
    private remarkid!: number;
    private updatedbyroleRemark!: string;
    private return_comments!:string;

    constructor() { }

    // Getters & Setters
    getOnboardingid(): number {
        return this.onboardingid;
    }
    setOnboardingid(onboardingid: number) {
        this.onboardingid = onboardingid;
    }


    getupdatedbyrole(): string {
        return this.updatedbyrole;
    }

    setupdatedbyrole(updatedbyrole: string) {
        this.updatedbyrole = updatedbyrole;
    }

    getpias_is_agree(): boolean {
        return this.pias_is_agree;
    }

    setpias_is_agree(pias_is_agree: boolean) {
        this.pias_is_agree = pias_is_agree;
    }

    getonboarding_name(): string {
        return this.onboarding_name;
    }

    setonboarding_name(onboarding_name: string) {
        this.onboarding_name = onboarding_name;
    }

    getpias_declaration_date(): string {
        return this.pias_declaration_date;
    }

    setpias_declaration_date(pias_declaration_date: string) {
        this.pias_declaration_date = pias_declaration_date;
    }

    getAttachments() {
        return this.attachments;
    }

    setAttachments(data: Attachements[]) {
        this.attachments = data;
    }

    getRemarkId(): number {
        return this.remarkid;
    }
    setRemarkId(remarkid: number) {
        this.remarkid = remarkid;
    }

    getReturnComments(): string {
        return this.return_comments;
    }
    setReturnComments(return_comments: string) {
        this.return_comments = return_comments;
    }

    getRemarkContent(): string {
        return this.remarkContent;
    }
    setRemarkContent(remarkContent: string) {
        this.remarkContent = remarkContent;
    }

    getupdatedbyroleRemark(): string {
        return this.updatedbyroleRemark;
    }
    setupdatedbyroleRemark(updatedbyroleRemark: string) {
        this.updatedbyroleRemark = updatedbyroleRemark;
    }



    toString() {
        return JSON.stringify({
            onboardingid: this.getOnboardingid(),
            updated_by_role: this.getupdatedbyrole(),
            remarks:this.getRemarkContent(),
            remark_id:this.getRemarkId(),
            updated_by_role_remark:this.getupdatedbyroleRemark(),
            pias_is_agree: this.getpias_is_agree(),
            pias_declaration_date: this.getpias_declaration_date(),
            onboarding_name: this.getonboarding_name(),
            attachments: this.getAttachments(),
            return_comments:this.getReturnComments()
        });
    }
}
